import {useAlternateHrefStore} from "../stores/AlternateHrefStore.js";

export function usePageMetadata() {

    const setMetaData = (pageType) => {
        const localeStore = useLocaleStore();
        if (!pageType?.meta) {
            return
        }

        const { title, hreflang, og, noindex, nofollow } = pageType.meta;
        let robotsContent = ['noindex', 'nofollow'];
        if (!noindex) {
            robotsContent = robotsContent.filter(item => item !== 'noindex');
        }

        if (!nofollow) {
            robotsContent = robotsContent.filter(item => item !== 'nofollow');
        }
        const metaTags = robotsContent.length > 0 ? [{ name: 'robots', content: robotsContent.join(',')}] : [];

        const headOptions = {
            titleTemplate: '%s',
            title,
            link: hreflang,
            meta: [
                ...metaTags,
                ...og,
            ],
        };

        useHead(headOptions);

        if (hreflang) {
            useAlternateHrefStore().setAlternateHref(hreflang);
        }
    }

    const setSchema = (pageType) => {
        if (!pageType?.schema) {
            return
        }

        try {
            const schemaArray = JSON.parse(pageType.schema)
            if (Array.isArray(schemaArray)) {
                schemaArray.forEach((schema) => {
                    useSchemaOrg(schema)
                })
            } else if (typeof schemaArray === 'object') {
                useSchemaOrg(schemaArray)
            }
        } catch (error) {
        }
    }

    const initializePageMetadata = (pageType) => {
        if (pageType) {
            setMetaData(pageType)
            setSchema(pageType)
        }
    }

    return {
        setMetaData,
        setSchema,
        initializePageMetadata,
    }
}
